import {PlainObject} from '@xh/hoist/core';
import {omit} from 'lodash';

export const defaultRsOptions = (extra: PlainObject = {}): PlainObject => {
    return {
        maxMenuHeight: 600,
        ...extra,
        styles: {
            singleValue: styles => omit(styles, ['maxWidth', 'position', 'transform']),
            menu: styles => ({
                ...styles,
                whiteSpace: 'nowrap',
                width: 'auto',
                margin: 0,
                padding: 0
            }),
            menuList: styles => ({
                ...styles,
                padding: 0,
                margin: 0
            }),
            group: styles => ({
                ...styles,
                paddingTop: 0
            }),
            groupHeading: styles => ({
                ...styles,
                padding: 0
            })
        }
    };
};
